import { render, staticRenderFns } from "./showGovSchemeInformation.vue?vue&type=template&id=12e858d2&"
import script from "./showGovSchemeInformation.vue?vue&type=script&lang=js&"
export * from "./showGovSchemeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports